// extracted by mini-css-extract-plugin
export default {"wrapper":"NonAccreditedItem_wrapper__-Hvkd","leftTxt":"NonAccreditedItem_leftTxt__hb6Zz","rightTxt":"NonAccreditedItem_rightTxt__+df+r"};